var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.dynamicIcon,_vm._g({tag:"component",staticClass:"svg-icon",attrs:{"width":_vm.width,"height":_vm.height}},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }